var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gw",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h160v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "M160 0h352v256H160z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#009e49",
    d: "M160 256h352v256H160z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-46.2 72.8) scale(.7886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "matrix(80 0 0 80 160 240)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0-1v1h.5",
    transform: "rotate(18 0 -1)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    transform: "scale(-1 1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(72 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(144 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-144 160 240)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    transform: "rotate(-72 160 240)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGw);
export default __webpack_public_path__ + "static/media/gw.a27c290b1227336d0a32c14c6df479d7.svg";
export { ForwardRef as ReactComponent };